import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environments';

@Injectable({
  providedIn: 'root'
})
export class ApiServiceService {

  constructor(private _http: HttpClient) {

  }

  getDetails(data: any) {
    return this._http.post(environment.apiUrl + 'api/get-tracking-details', data);
  }

  csvUpload(data: any): Observable<Blob> {
    return this._http.post<Blob>(environment.coreapiUrl + 'api/v2/tracking-downloadcsv', data, {
        responseType: 'blob' as 'json',
    });}



  // to send emails with csv
  sendEmailsWithCSV(data: any) {
    return this._http.post(environment.apiUrl + 'api/send-emails-csv', data);
  }

  getLCLDashboardOrdersEmailCSV(filter:any) {
    return this._http.post(environment.apiUrl + 'api/get-lcl-dashboard-orders-email-csv', filter);
  }
}
